export default function removeDuplicates(array, prop) {
  return (array || []).filter((obj, pos, arr) => obj && pos === arr.findIndex((t) => t && t[prop] === obj[prop]));
}

// // alternative for the removeDuplicates, have to decide if this is better
// export function filterUniq(arr) {
//   return [...new Set(arr.map(item => JSON.stringify(item)))].map(unique => JSON.parse(unique));
// }
